// extracted by mini-css-extract-plugin
module.exports = {"contents":"_2DTyB2M33425PAjFeqXW76","language":"z20lGqkcEFq0oVFN5WZsG","contract":"_1HPRDZPLQ-ejakszpyKon4","privacy":"xcOZVAcs7KoxJX_WjWF4t"};